import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Layout from '../components/Layout'
import Seo from '../components/seo'
import GridPosts from '../components/GridPosts'
import ItemPost from '../components/ItemPost'
import Hero from '../components/Hero'

const PostsPage = ({ data, pageContext }) => {
  const { allContentfulPost: { edges }, contentfulHero: { headLine, coverImage } } = data

  return (
    <Layout>
      <Seo title={`${pageContext.type} Posts`} description={headLine} />
      <Hero title={headLine} image={coverImage} />
      <section className='pull-top-100px'>
        <div className='container'>
          <div className='row'>
            {
              edges.slice(0, 3).map(({ node }, index) => <ItemPost key={index} {...node} column='col-lg-4' />)
            }
          </div>
        </div>
        <GridPosts posts={edges.slice(3)} pageContext={pageContext} />
      </section>
    </Layout>
  )
}

PostsPage.propTypes = {
  data: PropTypes.shape()
}

PostsPage.defaultProps = {
  data: {}
}

export default PostsPage

export const pageQuery = graphql`
  query AllBlogsByType ($skip: Int!, $limit: Int!, $type: String, $hero: String) {
    allContentfulPost(
      sort: { fields: createdAt, order: DESC }
      limit: $limit
      skip: $skip
      filter: { type: {eq: $type}}) {
      edges {
        node {
          slug
          title
          image {
            file {
              url
              fileName
            }
          }
          bodyContent {
            childMarkdownRemark {
              html
            }
          }
          categories {
            name
            slug
          }
        }
      }
    }
    contentfulHero(slug: {eq: $hero}) {
      headLine
      coverImage {
        file {
          url
          fileName
        }
      }
    }
  }
`
